import { PreviousSearches } from './actionTypes';
import { LocalStorageUtils } from '../../utils';
import { SearchService } from '../../services/SearchService';

const getInitialState = () => {
    const searchData = LocalStorageUtils.getJSON('search-data');
    LocalStorageUtils.setJSON('previous-search-data', searchData);
    const data = LocalStorageUtils.getJSON('previous-search-data') || [];
    return data.map(SearchService.toNewFormat);
};

const initialState = {
    items: getInitialState(),
};

const addItem = (state, action) => {
    const items = [action.item].concat(state.items);
    return { items };
};

export default function(state = initialState, action) {
    switch (action.type) {
        case PreviousSearches.ADD: {
            return addItem(state, action);
        }
        case PreviousSearches.INIT: {
            const items = getInitialState();
            return { ...state, items: items, isInitialized: true };
        }
        default:
            return state;
    }
}
